import React from "react";
import "../assets/css/Footer.css";

function Footer() {
    return (
        <footer>
            <p>© Copyright Kevin Hellman 2020</p>
        </footer>
    )
}

export default Footer;